<template>
  <vs-select v-model="consent">
    <vs-select-item
      :key="index"
      :value="item"
      :text="consentNames[index]"
      v-for="(item, index) in consentTypes"
    />
  </vs-select>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["condition", "automationId"],
  data() {
    return {
      consent: "",
    };
  },
  methods: {
    render() {
      return {
        consent: this.consent,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      consentTypes: "guestProfiles/consentTypes",
      consentNames: "guestProfiles/consentNames",
    }),
  },
  async mounted() {
    if (this.condition) {
      this.consent = this.condition.consent;
    }
  },
};
</script>

<style lang="scss">
</style>